// extracted by mini-css-extract-plugin
module.exports = {"icon":"IncomeExpenseCard_icon__2Y3S_","card":"IncomeExpenseCard_card__2EoPN"};